export enum ApiQueryKeys {
  MT_USERS_ME = 'MT_USERS_ME',
  MT_FILES = 'MT_FILES',
  MT_FILE_BY_ID = 'MT_FILE_BY_ID',
}
